import React from "react";

export const COMPANIES = {
  recruiter: React.lazy(() => import("./recruiter")),
};
